import { render } from "./HomeCenter.vue?vue&type=template&id=54fda4cd&scoped=true"
import script from "./HomeCenter.vue?vue&type=script&lang=js"
export * from "./HomeCenter.vue?vue&type=script&lang=js"

import "./HomeCenter.vue?vue&type=style&index=0&id=54fda4cd&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fda4cd"]])

export default __exports__